import { render } from "./ActivityInvitePage.vue?vue&type=template&id=6987d2b4&scoped=true"
import script from "./ActivityInvitePage.vue?vue&type=script&lang=js"
export * from "./ActivityInvitePage.vue?vue&type=script&lang=js"

import "./ActivityInvitePage.vue?vue&type=style&index=0&id=6987d2b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6987d2b4"]])

export default __exports__